import '../Style/Plane.css'
function Plane() {
    return (
        <>
             <div className="container-fluid row Plane pt-5 pb-5 d-flex justify-content-center align-items-center m-0">
            <div className="text-center col-10 mb-4 palne-main">
                <h1 className="display-4 title fw-bold ">Parenting Made Simple</h1>
                <p className="fw-bold display-4 text-white lh-1">
                    Expert guidance,
                    tailored to your family.
                </p>
                <h3 className="fw-bold lh-sm text-white">
                    Riley combines expert advice, predictive tracking tools, and tailored support to take the guesswork out of parenting your baby - day or night.
                    </h3>
                    <div className='row  plane-sliders d-flex align-items-center gap-3' >
                        <div className='col month '>
                            <div className='p-3'>
                                <h1>Month-to-month</h1>
                                <p>Billed Monthly.Cancel anytime</p>
                                <h2>$14.99 < span className='fs-5'>/month</span></h2>
                                <div className='btn-plane fw-bold p-3 mt-5 mb-5'>Choose This Plan</div>
                                <div className='text-start'>
                                    
                                <h5 className='fw-bold'>Get access to all membership features, including:</h5>
                                    <p>• Powered by Golden Window predictive tool, Riley forecasts your baby's sleep and feed times for better rest and peace of mind.</p>
                                    <p>•24/7 tailored parenting guidance via Riley's expert-trained chat</p>
                                    <p>•All-in-one integration: milestones, tracking, and recommendations</p>
                                </div>
                            </div>
                        </div>
                        <div className='col month-1 '>
                            <div className='p-3'>
                                <h1>Quarterly Plan</h1>
                                <p>Save 20%!</p>
                                <p>Billed every 3 months</p>
                                <h2>$11.99< span className='fs-5'>/month</span></h2>
                                <div className='btn-plane fw-bold p-3 mt-5 mb-5'>Choose This Plan</div>
                                <div className='text-start'>
                                    
                                <h5 className='fw-bold'>Everything in the Monthly Plan—plus a lower rate!</h5>
                                    <p>• Save 20% annually (equivalent to 3 months free)</p>
                                    <p>• Enjoy stress-free parenting for less</p>
                                <h5 className='fw-bold'>Get access to all features, including:</h5>
                                    <p>• Golden Window predictive tool for tailored Sleep and Feeding schedules</p>
                                    <p>• 24/7 tailored parenting guidance via Riley's expert-trained chat</p>
                                    <p>• All-in-one integration: milestones, tracking, and recommendations</p>
                                </div>
                        </div>
                        </div>
                        <div className='col year'>


                            <div className='p-3'>
                                <h1>Annual Plan</h1>
                                <p className=''>Save 4 Months!</p>
                                <p>Billed once a year.</p>
                                <h2>$9.99< span className='fs-5'>/month</span></h2>
                                <div className='btn-plane fw-bold p-3 mt-5 mb-5'>Choose This Plan</div>
                                <div className='text-start'>
                                    
                                <h5 className='fw-bold'>The best value for new parents, with all the features!!</h5>
                                    <p>• Save 33% annually (equivalent to 4 months free)</p>
                                    <p>• Access Riley's full suite of tools for an entire year of support.</p>
                                <h5 className='fw-bold'>GGet access to all features, including:</h5>
                                    <p>• Golden Window predictive tool for tailored Sleep and Feeding schedules`</p>
                                    <p>• 24/7 tailored parenting guidance via Riley's expert-trained chat</p>
                                    <p>• All-in-one integration: milestones, tracking, and recommendations</p>
                                </div>
                                </div>

                        </div>
                    </div>
            </div>
            </div>
        </>
    )
}
export default Plane;